// import Swiper from 'swiper';
import Swiper, { Navigation, Pagination } from 'swiper';

export default class Slider {
  slider: any;
  sliderContainer: any;

  constructor() {
    this.sliderContainer = document.querySelector('.swiper-container');
    this.slider = document.querySelector('.swiper');
    if (!this.slider || !this.sliderContainer) return;

    this.init();
  }

  init() {
    let counterMax = this.sliderContainer.querySelector('.swiper-counter__max')
    let counterCurrent = this.sliderContainer.querySelector('.swiper-counter__current')

    counterMax.textContent = this.slider.querySelectorAll('.swiper-slide').length;
    counterCurrent.textContent = '1';

    const swiper = new Swiper(this.slider, {
      loop: true,
      autoHeight: true,
      modules: [Navigation, Pagination],
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        activeIndexChange: (swiper) => {
          counterCurrent.textContent = swiper.realIndex + 1;
        }
      }
    });
  }
}
